import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deletePostCategory } from "../../../api/apiBlog";
import { toast } from "react-hot-toast";

export const useDeletePostCategory = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteCategoryMutate, isPending: isDeleting } = useMutation({
        mutationFn: deletePostCategory,
        onSuccess: (res) => {
            toast.success(res.message || "Category deleted successfully");
            queryClient.invalidateQueries(["post-categories"]);
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Error deleting category");
        },
    });

    return { deleteCategoryMutate, isDeleting };
};
